<template>
<div id="user-home">
  <VtoolBarHome></VtoolBarHome>
  <v-content>
    <MyCVList></MyCVList>
  </v-content>
</div>
</template>


<script>
  import MyCVList from '../components/MyCVList';
  import VtoolBarHome from '../components/VtoolBarHome';

  export default {
    name: "MyCVListView",
    components: {
      VtoolBarHome,
      MyCVList,
    },
    methods: {
      initWhoami() {
      // Permet de renseigner le store.
      // Tous les autres components peuvent accéder au store whoami
      // via mapState('whoami')
      this.$store.dispatch('whoami/getwho')
      },
    },
    mounted: function(){
      this.initWhoami(); // on renseigne le store au mount
    }
  }
</script>

<style>
  #user-home {
    background-image: url('../assets/hands-joined-team.jpg');
    /* background-color: #8f2c2c; */
    height: 100vh;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
  }
</style>
